export default function roles(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                role: action.role,
            }
        default:
            return state;
    }
}
